export function calculateReorderIndex(
  index: number,
  sourceIndex: number,
  destinationIndex: number
): number {
  if (index === sourceIndex) {
    return destinationIndex;
  }
  // source from bottom to top/equal current
  if (sourceIndex > index && destinationIndex <= index) {
    return index + 1;
  }
  // source from top to bottom/equal current
  if (sourceIndex < index && destinationIndex >= index) {
    return index - 1;
  }
  return index;
}
